import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa87cd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_button, {
      class: "px-3",
      loading: "",
      color: _ctx.color,
      size: _ctx.size
    }, null, 8, ["color", "size"])
  ]))
}